"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const chunk_1 = __importDefault(require("lodash/chunk"));
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importStar(require("react"));
const Radio_1 = __importDefault(require("../Radio"));
function RadioGroup(props) {
    const { children, disabled = false, columns = 1, value = '', options = [], onChange = doNothing_1.default, } = props;
    const handleChange = (0, react_1.useCallback)(e => onChange(e.target.value), [onChange]);
    const chunkedOptions = (0, chunk_1.default)(options, Math.ceil(options.length / columns));
    return (react_1.default.createElement(RadioGroup_1.default, { value: value, onChange: handleChange }, children || (react_1.default.createElement(Horizontal_1.default, { gutter: true, padding: true }, (0, range_1.default)(columns).map(cIdx => (react_1.default.createElement(Vertical_1.default, { key: 'col' + cIdx }, chunkedOptions[cIdx].map(option => (react_1.default.createElement(Radio_1.default, { disabled: disabled, key: option.value.toString(), value: option.value, checked: value === option.value, label: option.label }))))))))));
}
exports.RadioGroup = RadioGroup;
exports.default = RadioGroup;
